<template>
  <div>
    <b-row v-if="!isAuthInCurrentRegion" align-h="center">
      <b-col sm="12" md="6" lg="4" class="text-center">
          <div>
            <br>
            <label for="object-input-with-list">{{ $t("choose_product") }}</label>
            <v-select
              v-model="product"
              :options="products"
              label="name"
              code="id"
            ></v-select>
          </div>
      </b-col>
    </b-row>
    <b-row v-if="product" align-h="center">
      <b-col v-if="product.name==='bus77home' || product.name==='bus77lite' || product.name==='i3knx'" sm="12" md="6" lg="4" class="text-center">
        <AuthMulti source="cws" :service="service" />
      </b-col>
      <b-col v-else sm="12" md="6" lg="4" class="text-center">
        <Auth source="cws" :service="service" />
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col sm="12" md="12" lg="10" v-if="isAuthInCurrentRegion">
        <b-alert v-if="error && !showModal" show variant="danger">
          {{ error.description }}
        </b-alert>
        <div>
          <!-- <div v-show="this.serviceParams.debug=='y'"> -->
          <div v-if="product">
            <br />
            <div v-if="!projectsLoading">
              <label for="object-input-with-list">{{
                $t("choose_object", {product: this.product.name, service: $t(`cws_${service}`)} )
              }}</label>
              <v-select
                v-model="choosedObject"
                :options="objects"
                label="name"
                code="_id"
              >
              </v-select>
              <br />
              <b-button
                :disabled="!choosedObject"
                @click="showModal = true"
                block
                variant="primary"
                >{{ $t("link") }}</b-button
              >
            </div>
            <div v-else>
              <b-spinner type="grow" :label="$t('loading')"></b-spinner>
            </div>
          </div>
        </div>

        <br />
        <template v-if="extObjectTokens.length">
          <p class="">{{$t('activated_devices_for')}} {{$t(`cws_${service}`)}}</p>
          <b-table
            :busy="loading"
            :fields="extObjectTokenFields"
            striped
            hover
            :items="extObjectTokens"
            responsive="sm"
          >
            <template v-slot:cell(actions)="data" >
              <div class="text-right">
                <b-button
                  @click="unlinkToken(data.item)"
                  size="sm"
                  variant="outline-secondary">{{$t('unlink')}}
                </b-button>
              </div>
            </template>
          </b-table>
        </template>
        <b-alert
          show
          variant="default"
          v-if="!extObjectTokens.length && choosedObject && !loading"
        >
          <p>
            {{$t('no_services_linked_to')}}
            <b>{{ choosedObject.name }}</b>
          </p>
          <hr />
          <p class="mb-0">{{$t('click_link_for_bind')}}</p>
        </b-alert>
      </b-col>
    </b-row>

    <b-modal
      v-if="choosedObject"
      hide-footer
      v-model="showModal"
      ref="link_service"
      :title="$t('link_modal_title')"
    >
      <b-form @submit="linkService">
        <b-alert v-if="error" show variant="danger">{{
          error.description
        }}</b-alert>

        <b-form-group
          :label="$t('device_name')"
          label-for="device_name"
          :description="$t('device_name_desc')"
        >
        <template v-if="seviceDeviceNames">
          <b-form-select
            v-model="deviceParams.device_name"
            :options="seviceDeviceNames.devices.map( d => d.name)"
          ></b-form-select>
        </template>
        <template v-else>
          <b-form-input
            id="device_name"
            v-model="deviceParams.device_name"
            type="text"
            required
            :placeholder="$t('enter_device_name')"
          ></b-form-input>
        </template>

        </b-form-group>
        <b-form-group
          :label="$t('custom_data')"
          label-for="custom_data"
          :description="$t('custom_data_desc')"
        >
          <b-form-textarea
            id="custom_data"
            v-model="deviceParams.custom_data"
            :placeholder="$t('enter_custom_data')"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <br />
        <b-button block type="submit" variant="primary"
          >{{$t('link_modal_button', modalTitle)}}</b-button
        >
      </b-form>
    </b-modal>
    <b-col v-if="loading" class="text-center mt-4">
      <b-spinner type="grow" :label="$t('loading')"></b-spinner>
    </b-col>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-alert */
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import api from '../api'
import Auth from '../components/Auth.vue'
import AuthMulti from '../components/AuthMulti.vue'
import helper from '../../helper'

export default {
  components: {
    Auth,
    AuthMulti,
    'v-select': vSelect,
  },
  data() {
    return {
      error: null,
      loading: false,
      projectsLoading: false,
      service: null,
      objects: [],
      choosedObject: null,
      serviceParams: null,
      token: '',
      objectApiUrl: null,
      extObjectTokens: [],
      showModal: false,
      deviceParams: {
        device_name: '',
        custom_data: '',
      },
      product: null,
      products: [
        { name: 'i3knx', code: 'i3knx' },
        // { name: 'i3lite', code: 'i3lite' },
        { name: 'i3pro', code: 'i3pro_bx' },
        { name: 'bus77home', code: 'bus77_home' },
        { name: 'bus77lite', code: 'bus77_lite' },
      ],
      seviceDeviceNames: null,
    }
  },
  computed: {
    hosts() {
      return helper.hosts.filter((r) => r.available)
    },
    extObjectTokenFields() {
      return [
        {
          key: 'device_meta.device_name',
          label: this.$t('device'),
        },
        {
          key: 'createdAt',
          label: this.$t('created_at'),
        },
        {
          key: 'actions',
          label: '', // this.$t('actions'),
        },
      ]
    },
    modalTitle() {
      return {
        objectName: this.choosedObject.name, service: this.$t(`cws_${this.service}`),
      }
    },
    productApiUrl() {
      return this.product && this.region
        ? `${this.region.hosts[this.product.code]}/api/front/protected`
        : null
    },
    region() {
      return this.$root.$data.state.choosedRegion
    },
    // isAuthInCurrentRegion() {
    //   console.log('isAuthInCurrentRegion', this.$root.$data.state.auth)
    //   return (
    //     this.region
    //     && this.$root.$data.state.auth[this.region.code]
    //     && this.$root.$data.state.auth[this.region.code].token
    //     && this.$root.$data.state.auth[this.region.code].expTokenJsTimestamp
    //       > Date.now()
    //   )
    // },
    isAuthInCurrentRegion() {
      return (
        this.region
        && this.$root.$data.state.auth
        && this.$root.$data.state.auth.token
        && this.$root.$data.state.auth.expTokenJsTimestamp
          > Date.now()
      )
    },
  },
  watch: {
    showModal() {
      this.error = null
    },
    product: {
      deep: true,
      handler() {
        this.error = null
        this.choosedObject = null
        this.extObjectTokens = []
        if (this.isAuthInCurrentRegion) {
          this.getObjects()
        }
      },
    },
    isAuthInCurrentRegion(isSuccessAuth) {
      if (isSuccessAuth) {
        this.getObjects()
      }
    },
    choosedObject: {
      deep: true,
      handler(val) {
        const choosedHost = this.hosts.filter((c) => c.code === val.region.code)[0]
        if (choosedHost) {
          this.objectApiUrl = `${choosedHost.hosts[this.product.code]}/api/front/protected`
        }
        if (this.isAuthInCurrentRegion) {
          this.getTokens()
        }
        this.seviceDeviceNames = null
        this.deviceParams.device_name = ''
        this.deviceParams.custom_data = ''

        if (val && val.object_cws_devices) {
          const deviceNames = val.object_cws_devices.find(s => s.code === this.service)
          if (deviceNames) {
            this.seviceDeviceNames = deviceNames
            if (Array.isArray(deviceNames.devices) && deviceNames.devices.length > 0) {
              this.deviceParams.device_name = deviceNames.devices[0].name
              if (deviceNames.devices[0].custom_data) {
                this.deviceParams.custom_data = deviceNames.devices[0].custom_data
              }
            }
          }
        }
      },
    },
  },
  methods: {
    handleError(response, code) {
      if (code === 200) {
        this.error = response
      } else if (response && response.status !== 500) {
        this.error = response.data.error
      } else {
        this.error = {
          type: this.$t('server_error'),
          description: this.$t('try_again_later'),
        }
      }
    },
    handleErrorBCWS(errorObject) {
      if (errorObject.error_details || errorObject.error) {
        if (errorObject.error_details) {
          this.error = {
            type: this.$t(errorObject.error_details.error),
            description: this.$t(errorObject.error_details.error_description),
          }
        } else if (Array.isArray(errorObject.error)) {
          this.error = {
            type: this.$t(errorObject.error[0]),
            description: this.$t(errorObject.error[1]),
          }
        } else {
          this.error = errorObject.error
        }
      } else {
        this.error = {
          type: this.$t('server_error'),
          description: this.$t('try_again_later'),
        }
      }
    },
    async getObjects() {
      if (!this.productApiUrl) {
        console.log('productApiUrl undefinded')
        return
      }
      if (!this.product) {
        return
      }
      const uniq = {}
      this.projectsLoading = true
      console.log(this.product.name)
      console.log(this.hosts)
      if (this.product.name === 'bus77home' || this.product.name === 'bus77lite' || this.product.name === 'i3knx') {
        console.log('multi')
        // eslint-disable-next-line no-restricted-syntax
        const errors = []
        for (const region of this.hosts) {
          try {
            const res = await api.withAuth.get(
              `${region.hosts[this.product.code]
              }/api/front/protected/user/objects`, { region: region.code },
            )
            res.data.data.forEach((obj) => {
              uniq[`${obj.id}:${region.code}`] = {
                crossId: `${region.code}:${obj.id}`,
                objectId: obj.id,
                object_cws_devices: obj.object_cws_devices,
                objectUid: obj._id,
                region: {
                  name: region.name,
                  code: region.code,
                },
                name:
                // this.hosts.length > 1 ? `${obj.name} [${region.code}]` : obj.name,
                obj.name,
                product: this.product,
              }
            })
          } catch ({ response }) {
            if (response) {
              errors.push(response)
            }
            // if (response) {
            //   if (response.data) {
            //     this.handleErrorBCWS(response.data)
            //   } else {
            //     this.handleError(response)
            //   }
            // }
          }
        }
        if (errors.length === this.hosts.length) {
          if (errors[0].data) {
            this.handleErrorBCWS(errors[0].data)
          } else {
            this.handleError(errors[0])
          }
        }
      } else {
        const hosts = helper.hosts.filter((r) => r.code === this.region.code)

        // eslint-disable-next-line no-restricted-syntax
        for (const region of hosts) {
          try {
            const res = await api.withAuth.get(
              `${
                region.hosts[this.product.code]
              }/api/front/protected/user/objects`,
            )
            res.data.data.forEach((obj) => {
              uniq[`${obj.id}:${region.code}`] = {
                crossId: `${region.code}:${obj.id}`,
                objectId: obj.id,
                object_cws_devices: obj.object_cws_devices,
                objectUid: obj._id,
                region: {
                  name: region.name,
                  code: region.code,
                },
                name:
                  // this.hosts.length > 1 ? `${obj.name} [${region.code}]` : obj.name,
                  obj.name,
                product: this.product,
              }
            })
          } catch ({ response }) {
            if (response.data) {
              this.handleErrorBCWS(response.data)
            } else {
              this.handleError(response)
            }
          }
        }
      }

      this.objects = Object.values(uniq)
      this.projectsLoading = false
    },
    getTokens() {
      if (!this.choosedObject) {
        return
      }
      if (!this.productApiUrl) {
        return
      }
      this.loading = true
      if (this.product.name === 'bus77home' || this.product.name === 'bus77lite' || this.product.name === 'i3knx') {
        if (!this.objectApiUrl) {
          return
        }
      }
      if (this.product.name === 'bus77home' || this.product.name === 'bus77lite' || this.product.name === 'i3knx') {
        api.withAuth
          .get(
            `${this.objectApiUrl}/user/object/${
              this.choosedObject.objectId
            }/cws/tokens${this.service ? `?service=${this.service}` : ''}`, { region: this.choosedObject.region.code },
          )
          .then((res) => res.data)
          .then((res) => {
            console.log('res', res)
            this.extObjectTokens = res.data.length
              ? res.data.filter((t) => t.active)
                .map(t => {
                  t.createdAt = t.created_at ? t.created_at : t.createdAt

                  if (!t.device_meta) {
                    t.device_meta = {
                      device_name: this.$t('device_name_not_used'),
                      custom_data: '',
                    }
                  }

                  return t
                })
                .map(t => {
                  t.createdAt = t.createdAt ? new Date(t.createdAt).toLocaleString() : this.$t('created_undefined')
                  return t
                })
              : []
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleErrorBCWS(response.data)
            } else {
              this.handleError()
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        api.withAuth
          .get(
            `${this.productApiUrl}/user/object/${
              this.choosedObject.objectId
            }/cws/tokens${this.service ? `?service=${this.service}` : ''}`,
          )
          .then((res) => res.data)
          .then((res) => {
            console.log('res', res)
            this.extObjectTokens = res.data.length
              ? res.data.filter((t) => t.active)
                .map(t => {
                  t.createdAt = t.created_at ? t.created_at : t.createdAt

                  if (!t.device_meta) {
                    t.device_meta = {
                      device_name: this.$t('device_name_not_used'),
                      custom_data: '',
                    }
                  }

                  return t
                })
                .map(t => {
                  t.createdAt = t.createdAt ? new Date(t.createdAt).toLocaleString() : this.$t('created_undefined')
                  return t
                })
              : []
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleErrorBCWS(response.data)
            } else {
              this.handleError()
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    linkService(e) {
      e.preventDefault()
      if (!this.productApiUrl) return

      if (['bus77home', 'bus77lite', 'i3knx'].includes(this.product.name)) {
        if (!this.objectApiUrl) return
      }

      if (!this.service) {
        this.error = 'undefined linked sevice undefined'
        return
      }

      this.error = null
      this.loading = true

      const apiUrl = ['bus77home', 'bus77lite', 'i3knx'].includes(this.product.name)
        ? this.objectApiUrl
        : this.productApiUrl

      const requestData = {
        oid: this.choosedObject.objectId,
        serviceParams: this.serviceParams,
        deviceParams: this.deviceParams,
        product: this.product,
        region: this.region,
        lang: this.$i18n.locale,
      }

      api.withAuth
        .post(`${apiUrl}/user/services/${this.service}/link`, requestData)
        .then((res) => res.data)
        .then((res) => {
          if (res.error) {
            this.handleError(res.error, 200)
            return
          }
          const authUrl = res.data.authLink || res.data.auth_link
          if (authUrl) {
            window.location.href = authUrl
          }
        })
        .catch(({ response }) => {
          if (response?.data) {
            this.handleErrorBCWS(response.data)
          } else {
            this.handleError(response)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    unlinkToken(token) {
      if (!this.productApiUrl) {
        return
      }
      if (this.product.name === 'bus77home' || this.product.name === 'bus77lite' || this.product.name === 'i3knx') {
        if (!this.objectApiUrl) {
          return
        }
      }
      if (!token) {
        this.error = 'undefined token'
        return
      }

      const ok = () => {
        this.loading = true
        if (this.product.name === 'bus77home' || this.product.name === 'bus77lite' || this.product.name === 'i3knx') {
          api.withAuth
            .post(`${this.objectApiUrl}/user/services/${this.service}/unlink`, {
              token,
              oid: this.choosedObject.objectId,
              lang: this.$i18n.locale,
            })
            .then(() => {
              this.getTokens()
            })
            .catch(({ response }) => {
              if (response.data) {
                this.handleErrorBCWS(response.data)
              } else {
                this.handleError(response)
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          api.withAuth
            .post(`${this.productApiUrl}/user/services/${this.service}/unlink`, {
              token,
              oid: this.choosedObject.objectId,
              lang: this.$i18n.locale,
            })
            .then(() => {
              this.getTokens()
            })
            .catch(({ response }) => {
              if (response.data) {
                this.handleErrorBCWS(response.data)
              } else {
                this.handleError(response)
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
      this.$confirm.show(this.$t('are_you_sure_to_unlink'), ok)

      // eslint-disable-next-line no-restricted-globals
      // if (confirm(this.$t('are_you_sure_to_unlink'), ok)) {
      //   ok()
      // }
    },
  },
  mounted() {
    this.serviceParams = this.$route.query
    this.service = this.$route.params.externalService
    if (this.token) {
      this.getObjects()
    }

    // this.product = this.products[0]

    // if (this.products.length === 1) {
    //   this.product = this.products[0]
    // }
  },
}
</script>
